import { render, staticRenderFns } from "./advocacy-alert-item.vue?vue&type=template&id=186de94a&"
import script from "./advocacy-alert-item.vue?vue&type=script&lang=js&"
export * from "./advocacy-alert-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('186de94a', component.options)
    } else {
      api.reload('186de94a', component.options)
    }
    module.hot.accept("./advocacy-alert-item.vue?vue&type=template&id=186de94a&", function () {
      api.rerender('186de94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/listing/advocacy-alert-item.vue"
export default component.exports